import { DOWNLOAD_AUDIO_TYPE_VALUES } from "@/constants/posthog/downloadAudio";

// We use navigator.sendBeacon instead of a server action because Firefox cancels in-flight fetch requests (including server actions) when a download link is clicked. sendBeacon is guaranteed by the browser to complete even during navigation/download. The corresponding API route is at /api/posthog/track-download.
export const trackAudioDownload = ({
  audioType,
  entityId,
}: {
  audioType: (typeof DOWNLOAD_AUDIO_TYPE_VALUES)[number];
  entityId: string;
}) => {
  try {
    navigator.sendBeacon(
      "/api/posthog/track-download",
      new Blob([JSON.stringify({ audioType, entityId })], {
        type: "application/json",
      })
    );
  } catch (err) {
    console.error(err);
  }
};
